import React, { useState } from 'react';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import { CHECKBOX_STATUSES } from '../../../constants/orderStatuses';
import './StatusCheckbox.css';

const StatusCheckbox = ({ 
  orderId, 
  tenantId, 
  statusType, 
  isChecked, 
  onStatusChange,
  disabled = false 
}) => {
  const [loading, setLoading] = useState(false);

  const handleChange = async (e) => {
    if (disabled || loading) return;

    const newChecked = e.target.checked;
    setLoading(true);

    try {
      await onStatusChange({
        pedidoId: orderId,
        tenantId,
        statusType,
        isChecked: newChecked
      });
    } catch (error) {
      console.error('Error updating checkbox status:', error);
      // Revert the checkbox state on error
      e.target.checked = !newChecked;
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="checkbox-group">
      <label className="checkbox-label">
        <input
          type="checkbox"
          className="status-checkbox"
          checked={isChecked}
          onChange={handleChange}
          disabled={disabled || loading}
        />
        <span className="checkbox-text">
          {statusType === 'separacao' ? 'Separação' : 'Produção'}
        </span>
        {loading && (
          <div className="loading-spinner checkbox-loading">
            <LoadingSpinner size="small" />
          </div>
        )}
      </label>
    </div>
  );
};

export default StatusCheckbox;
